<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div *ngIf="sheetType === 'protection'; else encryption">
<h2 class="protection-level-title" appLifecycleTracker trackerName="protection-level-bottom-sheet">
  <span class="mdi mdi-lock" aria-hidden="true"></span>
  {{'PROTECTION_LEVEL' | translate}}
</h2>
<mat-divider></mat-divider>
<mat-nav-list class="list">
    <div class="list-item" mat-list-item attr.aria-label='When set to None {{topicDescription}} will never require authentication even when a threat is detected.'>
      <span aria-hidden="true" class="list-item-label" mat-line>
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [disabled]="true" value="none" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="none" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
            <mat-button-toggle value="medium" disableRipple="true">Dynamic</mat-button-toggle>
            <mat-button-toggle value="high" disableRipple="true">Always on</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
      </span>
      <span aria-hidden="true" class="list-item-value" mat-line>
        {{'WHEN_SET_TO' | translate}}
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [disabled]="true" value="none" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="none" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
        {{topicDescription}} {{'NONE_DESCRIPTION' | translate}}
      </span>
    </div>
    <div class="list-item" mat-list-item attr.aria-label='When set to Dynamic {{topicDescription}} will require authentication only when a threat has been detected.'>
      <span aria-hidden="true" class="list-item-label" mat-line>
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" aria-hidden="true" [disabled]="true" value="medium" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="none" disableRipple="true">{{'NONE' | translate}}</mat-button-toggle>
            <mat-button-toggle value="medium" disableRipple="true" [checked]="true">Dynamic</mat-button-toggle>
            <mat-button-toggle value="high" disableRipple="true">Always on</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
      </span>
      <span aria-hidden="true" class="list-item-value" mat-line>
        {{'WHEN_SET_TO' | translate}}
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [disabled]="true" value="medium" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="medium" disableRipple="true" [checked]="true">Dynamic</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
        {{topicDescription}} {{'DYNAMIC_DESCRIPTION' | translate}}
      </span>
    </div>
    <div class="list-item" mat-list-item attr.aria-label='When set to Always on {{topicDescription}} will always require authentication.'>
      <span aria-hidden="true" class="list-item-label" mat-line>
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" aria-hidden="true" [disabled]="true" value="high" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="none" disableRipple="true">{{'NONE' | translate}}</mat-button-toggle>
            <mat-button-toggle value="medium" disableRipple="true">Dynamic</mat-button-toggle>
            <mat-button-toggle value="high" disableRipple="true" [checked]="true">Always on</mat-button-toggle>
          </mat-button-toggle-group>
        </span>        
      </span>
      <span aria-hidden="true" class="list-item-value" mat-line>
        {{'WHEN_SET_TO' | translate}}
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [disabled]="true" value="high" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="high" disableRipple="true" [checked]="true">Always on</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
        {{topicDescription}} {{'ALWAYS_ON_DESCRIPTION' | translate}}
      </span>
    </div>
    <div class="list-item" mat-list-item>
      <span class="list-item-label" mat-line>
        {{'NOTE' | translate}}:
      </span>
      <span class="list-item-value" mat-line>
        {{'PROTECTION_LEVEL_NOTE' | translate}}
      </span>
    </div>
</mat-nav-list>
</div>
  <ng-template #encryption>
    <h2 class="protection-level-title" appLifecycleTracker trackerName="encryption-level-bottom-sheet">
      <span class="mdi mdi-zip-box-outline" aria-hidden="true"></span>
    {{'ENCRYPTION_LEVEL' | translate}}
  </h2>
  <mat-divider></mat-divider>
  <mat-nav-list class="list">
    <div class="list-item" mat-list-item attr.aria-label='When set to None {{topicDescription}} will not be encrypted.'>
      <span aria-hidden="true" class="list-item-label" mat-line>
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [disabled]="true" value="none" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="none" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
            <mat-button-toggle value="encrypted" disableRipple="true">Subscription</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
      </span>
      <span aria-hidden="true" class="list-item-value" mat-line>
        {{'WHEN_SET_TO' | translate}}
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [disabled]="true" value="none" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="none" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
        {{topicDescription}} {{'ENCRYPT_LEVEL_NONE' | translate}}
      </span>
    </div>
    <div class="list-item" mat-list-item attr.aria-label='When set to Dynamic {{topicDescription}} will be encrypted with your subscription key.'>
      <span aria-hidden="true" class="list-item-label" mat-line>
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" aria-hidden="true" [disabled]="true" value="medium" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="none" disableRipple="true">{{'NONE' | translate}}</mat-button-toggle>
            <mat-button-toggle value="medium" disableRipple="true" [checked]="true">Subscription</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
      </span>
      <span aria-hidden="true" class="list-item-value" mat-line>
        {{'WHEN_SET_TO' | translate}}
        <span class="legend-policy-toggle-button-group">
          <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [disabled]="true" value="medium" appearance="standard" name="policy-toggle-button-group">
            <mat-button-toggle value="medium" disableRipple="true" [checked]="true">Subscription</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
        {{topicDescription}} {{'ENCRYPT_LEVEL_SUBSCRIPTION' | translate}}
      </span>
    </div>
    <div class="list-item" mat-list-item>
      <span class="list-item-label" mat-line>
        {{'NOTE' | translate}}:
      </span>
      <span class="list-item-value" mat-line>
        {{'ENCRYPTION_NOTE' | translate}} <a [routerLink]="['/admin-settings']">{{'SETTINGS_PAGE' | translate}}</a>.
      </span>
    </div>
  </mat-nav-list>
</ng-template>